<admin-page-tab-section>
  <admin-panel-configurable [title]="'Checks'">
      <admin-panel-inner *ngFor="let item of checks" customs="py-2 mb-4 fs-5 rounded-1 config-item-panel config-item-border" border="{{ renderBorder(item) }}">
        <div class="row">
          <div class="col-4">
            <span class="">list channel</span>
            <div class="text-dark message-content border" style="border-style: dashed !important;">
              {{ item.listOwner + " / " + item.listVertical + " / " + item.listCode }}
            </div>
          </div>

          <div class="col-2">
            <span class="">list field</span>
            <div class="text-dark message-content border" style="border-style: dashed !important;">
              {{ item.listField }}
            </div>
          </div>

          <div class="col-2">
            <span class="">data field</span>
            <div class="text-dark message-content border" style="border-style: dashed !important;">
              {{ item.dataField }}
            </div>
          </div>

          <div class="col-2">
            <span class="">{{ 'pages.channels.view.checks.definition' | translate }}</span>
            <div class="text-dark message-content border" style="border-style: dashed !important;">
              {{ item.definition }}
            </div>
          </div>

          <div class="col-1">
            <span class="">{{ 'pages.channels.view.checks.threshold' | translate }}</span>
            <div class="text-dark message-content border threshold-label" style="border-style: dashed !important;">
              {{ (getNumberValue(item.threshold) * 100).toFixed(0) }}&nbsp;%
            </div>
          </div>

          <div class="col-1">
            <span class="">{{ 'pages.channels.view.checks.weight' | translate }}</span>
            <div class="text-dark message-content border weight-label" style="border-style: dashed !important;">
              {{ getNumberValue(item.value).toFixed(2) }}
            </div>
          </div>
        </div>

        <div class="row" *ngIf="item.reason">
          <div class="col-12">
            <div class="text-dark message-content border" style="border-style: dashed !important;">
              {{ item.reason }}
            </div>
          </div>
        </div>
      </admin-panel-inner>
  </admin-panel-configurable>
</admin-page-tab-section>
